import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from './context/LanguageContext';
import Layout from './pages/Layout';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import AccreditationsPage from './pages/AccreditationsPage';
import ContactPage from './pages/ContactPage';
import NewsPage from './pages/NewsPage';
import NewsArticlePage from './pages/NewsArticlePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import ScrollToTop from './components/ScrollToTop';

// ===== EBC Admin CMS =====
import { AdminAuthProvider } from './admin/AdminAuthContext';
import AdminLogin from './admin/AdminLogin';
import AdminLayout from './admin/AdminLayout';
import AdminOverview from './admin/AdminOverview';
import AdminNewsList from './admin/AdminNewsList';
import AdminNewsEditor from './admin/AdminNewsEditor';
import AdminMedia from './admin/AdminMedia';
import AdminSettings from './admin/AdminSettings';
import AdminPlaceholder from './admin/AdminPlaceholder';
import AdminContent from './admin/AdminContent';
import AdminCompany from './admin/AdminCompany';
import AdminContact from './admin/AdminContact';
import AdminLists from './admin/AdminLists';
import AdminHeroes from './admin/AdminHeroes';
import AdminGlobal from './admin/AdminGlobal';
import AdminSectionCopy from './admin/AdminSectionCopy';
import AdminStrategicGoals from './admin/AdminStrategicGoals';
import AdminContactPage from './admin/AdminContactPage';

// Category options reused by <AdminContent /> for collections that use them.
const PARTNER_CATEGORIES = [
  { value: 'government',    ar: 'حكومي',      en: 'Government' },
  { value: 'international', ar: 'دولي',       en: 'International' },
  { value: 'private',       ar: 'قطاع خاص',   en: 'Private Sector' },
];

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <AdminAuthProvider>
            <Routes>
              {/* PUBLIC WEBSITE — unchanged */}
              <Route element={<Layout />}>
                <Route path="/" element={<AboutPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/accreditations" element={<AccreditationsPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/news" element={<NewsPage />} />
                <Route path="/news/:id" element={<NewsArticlePage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                {/* Unknown routes (e.g. the retired /field-services URL) fall
                    back to the home page instead of rendering an empty layout. */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>

              {/* ADMIN DASHBOARD — protected */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminOverview />} />
                <Route path="news" element={<AdminNewsList />} />
                <Route path="news/:id" element={<AdminNewsEditor />} />
                <Route path="media" element={<AdminMedia />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="certificates"     element={<AdminContent collection="certificates"    titleKey="certificates"    showPdf />} />
                <Route path="services"         element={<AdminContent collection="services"        titleKey="services" />} />
                <Route path="projects"         element={<AdminContent collection="projects"        titleKey="projects" projectFields />} />
                <Route path="partners"         element={<AdminContent collection="partners"        titleKey="partners" categoryOptions={PARTNER_CATEGORIES} />} />
                <Route path="gallery"          element={<AdminContent collection="gallery"         titleKey="galleryPage" />} />
                <Route path="client-logos"     element={<AdminContent collection="client-logos"    titleKey="clientLogos" />} />
                <Route path="company"          element={<AdminCompany />} />
                <Route path="contact"          element={<AdminContact />} />
                <Route path="lists"            element={<AdminLists />} />
                <Route path="heroes"           element={<AdminHeroes />} />
                <Route path="global"           element={<AdminGlobal />} />
                <Route path="section-copy"     element={<AdminSectionCopy />} />
                <Route path="strategic-goals"  element={<AdminStrategicGoals />} />
                <Route path="contact-page"     element={<AdminContactPage />} />
              </Route>
            </Routes>
          </AdminAuthProvider>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
